import axios from 'axios';

import {
  CONTENT_TYPE_HEADER,
  JSON_CONTENT_TYPE,
  REQUEST_TYPES_WITH_BODY,
} from '../../common/network/networkConstants';
import {
  HTTP_STATUS_CODES,
} from '../../common/network/httpConstants';

function createBaseConfig() {
  return {};
}

function enhanceApiErrorMessageIfPossible(error) {
  let result;

  if (error.request && error.request.path) {
    result = `${error.message} at API call: ${error.request.path}`;
  } else {
    result = error.message;
  }

  return result;
}

class StorefrontApiManager {
  constructor(customConfig) {
    this.api = this.createInstance({
      ...createBaseConfig(),
      ...customConfig,
      headers: {
        common: {
          ...createBaseConfig.headers,
          ...customConfig ? customConfig.headers : null,
        },
      },
    });
  }

  createInstance(config) {
    const instance = axios.create(config);

    REQUEST_TYPES_WITH_BODY.forEach((requestType) => {
      instance.defaults.headers[requestType][CONTENT_TYPE_HEADER] = JSON_CONTENT_TYPE;
    });

    this.setInterceptors(instance);

    return instance;
  }

  getInstance() {
    return this.api;
  }

  setInterceptors(instance) {
    instance.interceptors.response.use(
      null,
      (error) => {
        let finalError;

        if (error.response) {
          finalError = {
            ...error,
            stack: error.stack,
            structuredStackTrace: error.structuredStackTrace,
            message: enhanceApiErrorMessageIfPossible(error),
          };
        } else {
          finalError = {
            ...error,
            config: error.config || {},
            stack: error.stack,
            structuredStackTrace: error.structuredStackTrace,
            message: enhanceApiErrorMessageIfPossible(error),
            response: {
              data: {},
              status: HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
            },
          };
        }

        return Promise.reject(finalError);
      },
    );
  }
}

export default StorefrontApiManager;



// WEBPACK FOOTER //
// ./src/core/api/StorefrontApiManager.js